import { usePageId } from '@marketplace-web/environment/request-context-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { SearchBarSearchType } from '@marketplace-web/search/search-feature'

export function useHeaderSearchType(): SearchBarSearchType {
  const pageId = usePageId()

  const aiPoweredHelpWebAbTest = useAbTest('ai_help_chatbot_v2')
  const isAiPoweredHelpFeatureEnabled = useFeatureSwitch('help_center_ai_powered_help')
  const isAiPoweredHelpEnabled =
    aiPoweredHelpWebAbTest?.variant === 'on' && isAiPoweredHelpFeatureEnabled

  if (pageId?.startsWith('member')) return SearchBarSearchType.User
  if (pageId?.startsWith('help'))
    return isAiPoweredHelpEnabled ? SearchBarSearchType.Item : SearchBarSearchType.Faq

  return SearchBarSearchType.Item
}
